import { render } from "./PostCell.vue?vue&type=template&id=3b2900a1&scoped=true"
import script from "./PostCell.vue?vue&type=script&lang=js"
export * from "./PostCell.vue?vue&type=script&lang=js"

import "./PostCell.vue?vue&type=style&index=0&id=3b2900a1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2900a1"]])

export default __exports__